namespace('compass.arctic');

compass.arctic.ShowInfoWidget = compass.defineWidget(function ShowInfoWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _d = jQuery.dom.getContext(this);

	this.render = function(widgetElem) {
		var mi = _settings.meetingInfo;
		
		// Add the widget class for styling
		widgetElem.addClass('ShowInfoWidget');
		
		// Check if we have an expanded instruction to display
		if (mi.expandedInstruction && mi.expandedInstruction.instructions) {
			// Render the expanded instruction directly
			// If it's markdown, we assume the backend has already converted markdown to HTML
			widgetElem.html(mi.expandedInstruction.instructions);
		} else {
			// Fall back to the standard display logic
			me.renderStandardDisplay(widgetElem);
		}
	};

	this.renderStandardDisplay = function(widgetElem) {
		var d = _d;
		var mi = _settings.meetingInfo;
		
		// Build the address display with special US handling
		var addr = d.div({ className: 'eventAddr' },
			d.span({ className: 'eventCity' }, mi.site.city)
		);

		if(mi.site.state) {
			addr.append(d.span({ className: 'eventState' }, ',&nbsp;', mi.site.state));
		}
		
		// Only show country if it's not United States
		if(mi.site.country && mi.site.country.toLowerCase() != 'united states') {
			addr.append(
				d.span({ className: 'eventCountry' }, 
					',&nbsp;', mi.site.country.toLowerCase()
				)
			);
		}

		var eventDetails = d.div({ className: 'eventDetails' },
			d.div({ className: 'eventDates' }, mi.datesDisplay),
			d.div({ className: 'eventLocation notranslate' }, mi.site.name),
			addr
		);

		// Handle hideMeetingSubheader flag
		if(mi.hideMeetingSubheader) {
			eventDetails.empty();
		}

		widgetElem.append(
			d.div({ className: 'eventName notranslate' }, mi.name),
			eventDetails
		);
	};

	// Helper method to get formatted address for use in other contexts
	this.getFormattedAddress = function() {
		var mi = _settings.meetingInfo;
		var parts = [];
		
		if (mi.site.city) {
			parts.push(mi.site.city);
		}
		
		if (mi.site.state) {
			parts.push(mi.site.state);
		}
		
		// Only include country if it's not United States
		if (mi.site.country && mi.site.country.toLowerCase() != 'united states') {
			parts.push(mi.site.country);
		}
		
		return parts.join(', ');
	};

	// Helper method to get just the event name
	this.getEventName = function() {
		return _settings.meetingInfo.name;
	};

	// Helper method to get just the dates display
	this.getDatesDisplay = function() {
		return _settings.meetingInfo.datesDisplay;
	};

	// Helper method to get just the site name
	this.getSiteName = function() {
		return _settings.meetingInfo.site.name;
	};
},
{
	WUID: 'showInfoWidgetWUID',
	widgetName: 'ShowInfoWidget',
	meetingInfo: {
		name: 'Default Meeting',
		datesDisplay: 'Jan 1-3, 2025',
		site: {
			name: 'Convention Center',
			city: 'Las Vegas',
			state: 'NV',
			country: 'United States'
		}
	}
});